import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

import {
  Query_Membership_OptionsInput,
  useMembershipFormQuery,
  useRemoveMembershipMutation
} from 'generated/graphql';

export type IFormState = {
  id: string;
  personId: string;
  projectId: string;
};

const initialState = {
  id: '',
  personId: '',
  projectId: ''
};

export function useFormState(personId: string, projectId: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      }
    }
  });


  const { data, called, loading } = useQuery({
    filter: {
      personId,
      projectId
    }
  });

  useEffect(() => {
    if (called && !loading && data.id !== '' && formState.id === '') {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          ...data
        }
      });
    }
  }, [
    called,
    data,
    dispatch,
    formState,
    loading
  ]);


  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useRemoveMembership() {
  const [
    fnMutate,
    tuple
  ] = useRemoveMembershipMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}


export interface IData extends IFormState {}

export function useQuery(options: Query_Membership_OptionsInput) {
  const skip = options.filter.personId === '' || options.filter.projectId === '';
  const tuple = useMembershipFormQuery({
    variables: {
      options
    },
    skip: skip
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.membership?.id ?? '',
        personId: tuple.variables?.options.filter.personId ?? '',
        projectId: tuple.variables?.options.filter.projectId ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

